<template>
  <div>
    <v-menu>
      <template v-slot:activator="{ on }">
        <v-btn text v-on="on" icon>
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list class="px-2" dense>
        <v-list-item class="py-1" @click="onRemove">
          <v-list-item-icon class="mr-2"><v-icon left>mdi-delete</v-icon></v-list-item-icon>
          <v-list-item-content>Xóa</v-list-item-content>
        </v-list-item>
        <v-list-item class="py-1" @click.stop="onTuition">
          <v-list-item-icon class="mr-2"><v-icon left>mdi-file-document</v-icon></v-list-item-icon>
          <v-list-item-content>Tạo học phí</v-list-item-content>
        </v-list-item>
        <StudentEditTags :single="true" :students="selected" />
        <v-list-item class="py-1" @click.stop="onActivate">
          <v-list-item-icon class="mr-2"><v-icon left>mdi-account-check</v-icon></v-list-item-icon>
          <v-list-item-content>Kích hoạt</v-list-item-content>
        </v-list-item>
        <v-list-item class="py-1" @click.stop="onReserve">
          <v-list-item-icon class="mr-2"><v-icon left>mdi-calendar</v-icon></v-list-item-icon>
          <v-list-item-content>Bảo lưu</v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <UpsertReservationDialog
      v-if="upsertReservationDialog.isOpen"
      :isOpen="upsertReservationDialog.isOpen"
      :isEdit="false"
      :fixedStudent="true"
      :currentItem="upsertReservationDialog.currentItem"
      @close="upsertReservationDialog.onCancel"
      @cancel="upsertReservationDialog.onCancel"
      @confirm="upsertReservationDialog.callback"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import UpsertReservationDialog from '@/components/UpsertReservationDialog.vue'
import moment from 'moment'

import StudentEditTags from '@/modules/student/StudentEditTags.vue'
import _ from 'lodash'
export default {
  components: {
    StudentEditTags,
    UpsertReservationDialog
  },
  props: {
    disabled: Boolean,
    filter: Boolean,
    selected: { type: Array, default: () => [] }
  },
  data() {
    return {
      upsertReservationDialog: {
        currentItem: null,
        isOpen: false,
        callback: () => {},
        onCancel: () => {
          this.upsertReservationDialog.isOpen = false
          this.upsertReservationDialog.isEdit = false
          this.upsertReservationDialog.currentItem = null
        }
      },
      mailDialogState: false,
      smsDialogState: false,
      smsEditingState: false,
      createState: false,
      sending: null
    }
  },
  computed: {
    ...mapState('student', ['students']),
    sendingName() {
      const { name } = this.students.find(student => student.phone === this.sending)
      return name
    },
    multipleAction() {
      return !_.isEmpty(this.selected)
    }
  },
  methods: {
    ...mapActions('students', ['removeStudents', 'updateStudents', 'requestPageSettings']),
    ...mapActions('student', ['fetchStudent']),
    ...mapActions('noti', ['sendEmails', 'sendSMS']),
    ...mapActions('sale', ['setStudents']),
    ...mapActions('reservation', ['createReservation']),
    disableStudent() {
      this.updateStudents(
        this.selected.map(item => {
          return { ...item, status: 'block' }
        })
      )
    },
    enableStudent() {
      this.updateStudents(
        this.selected.map(item => {
          return { ...item, status: 'active' }
        })
      )
    },
    onRemove() {
      this.$dialog.confirm({
        title: 'Xóa Học Sinh',
        text: 'Bạn có chắc muốn xóa học sinh này?',
        okText: 'Có',
        cancelText: 'Không',
        done: async () => {
          await this.removeStudents(this.selected)
          this.$emit('removed')
        }
      })
    },
    onReserve() {
      const studentId = _.get(this.selected[0], 'id')
      if (!studentId) return
      // this.$dialog.confirm({
      //   title: 'Bảo Lưu Học sinh',
      //   text: 'Bạn có muốn bảo lưu những học sinh này ?',
      //   okText: 'Có',
      //   cancelText: 'Không',
      //   done: async () => {
      //     await this.updateStudents(this.selected.map(s => ({ id: s.id, status: 'reserved' })))
      //     this.$emit('removed')
      //   }
      // })
      let data = {
        student: studentId,
        start_date: moment().startOf('day').toISOString(),
        end_date: undefined,
        process_completion_date: undefined,
        reason: '',
        note: '',
        reason_type: '',
        tuition_status: '',
        new_class: '',
        return_date: undefined,
        actual_return_date: undefined,
        new_class_date: undefined
      }
      this.upsertReservationDialog.currentItem = data
      this.upsertReservationDialog.isOpen = true
      this.upsertReservationDialog.callback = (async payload => {
        try {
          await this.createReservation({
            params: payload
          })
          this.$alert.success('Tạo thành công')
          await this.fetchStudent(
            this.upsertReservationDialog.currentItem.student.id ||
              this.upsertReservationDialog.currentItem.student
          )
        } catch (error) {
          console.error(error)
          this.$alert.error('Có lỗi xay ra')
        } finally {
          this.upsertReservationDialog.isOpen = false
          this.upsertReservationDialog.currentItem = null
          this.$emit('reserve')
        }
      }).bind(this)
    },
    onTuition() {
      this.setStudents(this.selected)
      this.$router.push('./sales')
    },
    onActivate() {
      this.$dialog.confirm({
        title: 'Bảo Lưu Học sinh',
        text: 'Bạn có muốn Chuyển trạng thái học viên này về đang hoạt động?',
        okText: 'Có',
        cancelText: 'Không',
        done: async () => {
          await this.updateStudents(this.selected.map(s => ({ id: s.id, status: 'active' })))
          this.$emit('removed')
        }
      })
    }
  }
}
</script>
